// THIS MARKER IS CURRENTLY NOT USED BUT WILL BE REINTRODUCED IN FUTURE WITH GOVERNMENT TIE-INS etc
import { displayLatLonInCompassFormat } from '@deckee/utilities';
import { trafficCone } from '../../../components/shared/vector-images';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Incident',
  synonyms: '',
  group: 'standardMarker',
  typeUrl: 'incident',
  icon: {
    baseShape: trafficCone,
    iconColor: '#fff',
    markerColor: '#B01515',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'important-alerts',
    order: 1000,
  },
  standardMarkerOptions: {
    markerType: 'incidentMarker',
    allowCreation: false,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Incident',
      itemTitleFunction: () => 'Incident',
    },
    creationOptions: {
      menuText: 'Incident',
      newTitle: 'Incident',
      titlePlaceholder: 'Title',
      markerTypeDescription: 'Share any other helpful information here...',
      checkBoxItems: [],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: layer.standardMarkerOptions.markerType,
    id: marker.id,
    displayChat: true,
    displayUpVotes: true,
    title: 'Incident',
    description: displayLatLonInCompassFormat(marker.latLon),
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

export default layer;
